module.exports = __webpack_public_path__ + "static/media/malenew.48a021a4.png";